import { useCallback, useEffect, useRef, useState } from "react";

import { PublicPostRequest } from "utils/ApiRequest";
import { currentPujoYear, sponsorsFromProducts } from "utils/sponsors";

/**
 * Sponsors for the season that is running now.
 *
 * The /sponsors/{year} archive is curated by hand after a season closes, so it will never carry the
 * current one. The products list is where the running year actually lives — an item goes off sale
 * and picks up a sponsor name the moment its contribution settles — and getUProducts serves it
 * without a session, which is what lets the landing page show it to a visitor who is not signed in.
 */
function useLiveSponsors() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const requestId = useRef(0);

  useEffect(() => {
    requestId.current += 1;
    const current = requestId.current;
    setLoading(true);
    setFailed(false);

    PublicPostRequest(
      "/getUProducts",
      {},
      (res) => {
        if (current !== requestId.current) return;
        const grouped = res.data != null ? res.data.productsResponses : null;
        const sponsorships =
          grouped != null && Array.isArray(grouped.SPONSORSHIP) ? grouped.SPONSORSHIP : [];
        setData(sponsorsFromProducts(sponsorships, currentPujoYear()));
        setLoading(false);
      },
      () => {
        if (current !== requestId.current) return;
        setData(null);
        setFailed(true);
        setLoading(false);
      }
    );
  }, [attempt]);

  const retry = useCallback(() => setAttempt((value) => value + 1), []);

  return { data, loading, failed, retry };
}

export default useLiveSponsors;
